import { Column } from 'react-table';
import type { TFunction } from 'i18next';
import { Typography } from '@mui/material';
import { ContextMenuButton, TableHeader } from 'redesign';
import { PartnerUserCellProp, PartnerUserColumnDefinition } from './partner-user.types';

export const getPartnerUserColumnDefinition = (
  t: TFunction<'hq-screen-specific' | 'web-common', undefined>
): Column<PartnerUserColumnDefinition>[] => {
  const userName: Column<PartnerUserColumnDefinition> = {
    Header: () => (
      <TableHeader>
        {t('bank_account.table_headers.name ', { ns: 'hq-screen-specific' })}
      </TableHeader>
    ),
    accessor: 'userName',
    Cell: UserNameCell,
  };
  const email: Column<PartnerUserColumnDefinition> = {
    Header: () => <TableHeader>{t('table_headers.email', { ns: 'web-common' })}</TableHeader>,
    accessor: 'email',
    Cell: EmailCell,
  };
  const telephone: Column<PartnerUserColumnDefinition> = {
    Header: <TableHeader>{t('table_headers.phone', { ns: 'web-common' })}</TableHeader>,
    accessor: 'phoneNumber',
    Cell: PhoneNumberCell,
  };

  const actions: Column<PartnerUserColumnDefinition> = {
    accessor: 'actions',
    Header: '',
    Cell: ActionCell,
  };

  return [userName, email, telephone, actions];
};

const ActionCell = (cell: PartnerUserCellProp<'actions'>) => {
  const actions = cell.getRowActions(cell.value);

  if (actions.length === 0) {
    return null;
  }

  return (
    <ContextMenuButton menuId={`partner-user-actions-menu-${cell.value.userId}`}>
      {actions}
    </ContextMenuButton>
  );
};

const UserNameCell = (cell: PartnerUserCellProp<'userName'>) => {
  return <Typography variant="subtitle2">{cell.value}</Typography>;
};

const EmailCell = (cell: PartnerUserCellProp<'email'>) => {
  return <Typography variant="subtitle2">{cell.value}</Typography>;
};

const PhoneNumberCell = (cell: PartnerUserCellProp<'phoneNumber'>) => {
  return <Typography variant="subtitle2">{cell.value}</Typography>;
};
